/// <summary>A value set type recognized by the SI-PMI API.</summary>
enum ValueSetType {
    /// <summary>Reasons for administering a vaccine.</summary>
    AdministrationReason,

    /// <summary>Vaccination methods (e.g. oral or subcutaneous).</summary>
    AdministrationRoute,

    /// <summary>Locations where vaccines can be administered (e.g. left arm).</summary>
    AdministrationSite,

    /// <summary>Relationship types for the person who gave consent for a vaccination.</summary>
    ConsentGivenByType,

    /// <summary>Relationship types for a person registered as the patient's contact.</summary>
    ContactType,

    /// <summary>Reasons for a contraindication.</summary>
    ContraindicationReason,

    /// <summary>Reasons for the deletion of a vaccination.</summary>
    DeletionReason,

    /// <summary>Vaccine dosage units (e.g. drops or vials).</summary>
    DosageUnit,

    /// <summary>The evidence provided for immunity (e.g. medical certificate or history of varicella).</summary>
    EvidenceSource,

    /// <summary>The status for an expected vaccination (e.g. late or up-to-date).</summary>
    ForecastStatus,

    /// <summary>Patient genders (i.e. male, female, or unknown).</summary>
    Gender,

    /// <summary>A provincial health card type (e.g. "Carte assurance maladie du Québec").</summary>
    HealthCardIssuer,

    /// <summary>An identifier type (e.g. health card).</summary>
    IdentifierType,

    /// <summary>Country codes for a patient.</summary>
    Country,

    /// <summary>Reasons for overriding a vaccination record.</summary>
    OverrideReason,

    /// <summary>Medical practitioner types (e.g. nurse or doctor).</summary>
    PractitionnerRole,

    /// <summary>Immunizing agents.</summary>
    Agent,

    /// <summary>Immunity antigens.</summary>
    Antigen,

    /// <summary>Reasons for moving a vaccination record back to the 'to forecast' status in the calendar.</summary>
    SetToForecastReason,

    /// <summary>A special consideration type (e.g. contraindication or exception).</summary>
    SpecialConsiderationType,

    /// <summary>Commercial trade names for recognized vaccines.</summary>
    TradeName,

    /// <summary>Reasons for a vaccination refusal.</summary>
    VaccinationRefusalMotive
}

export { ValueSetType };
